// extracted by mini-css-extract-plugin
module.exports = {"f-OrganismFooter":"Footer_f-OrganismFooter__SHFuQ","f-OrganismFooter-menu":"Footer_f-OrganismFooter-menu__rM_t8"};